// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"TY-z","subtitle":"UY-z","wrapper":"VY-z","leftArrow":"WY-z","rightArrow":"XY-z"};